/**
 * 媒体工具
 * 用途：统一图片 / 视频媒体项结构，供详情页画廊复用
 * 用法：
 *   normalizeMediaList(gallery, coverImage)
 *   支持字符串 URL，或 { type, src, poster } 对象
 */

/** 根据 URL 后缀判断是否为视频 */
export function isVideoUrl(url = '') {
  return /\.(mp4|webm|ogg)(\?|$)/i.test(url)
}

/**
 * 规范化单条媒体
 * @param {string|{type?:string,src:string,poster?:string}} item
 * @param {number} index
 */
export function normalizeMediaItem(item, index = 0) {
  if (!item) return null

  if (typeof item === 'string') {
    const type = isVideoUrl(item) ? 'video' : 'image'
    return {
      id: `media-${index}`,
      type,
      src: item,
      poster: type === 'image' ? item : ''
    }
  }

  const type = item.type || (isVideoUrl(item.src) ? 'video' : 'image')
  return {
    id: item.id || `media-${index}`,
    type,
    src: item.src,
    poster: item.poster || (type === 'image' ? item.src : '')
  }
}

/**
 * 规范化媒体列表；列表为空时可用 fallbackImage 作为默认图
 * 用法：normalizeMediaList(product.gallery, product.src)
 */
export function normalizeMediaList(list = [], fallbackImage = '') {
  const source = Array.isArray(list) && list.length
    ? list
    : fallbackImage
      ? [fallbackImage]
      : []

  return source
    .map((item, index) => normalizeMediaItem(item, index))
    .filter(Boolean)
}
